import Radio from "backbone.radio";
import { toast } from "extensions/toast";

import strings from "common/strings";
import { emitter } from "common/emitter";

import { Dialog } from "common/components/dialog/dialog";

import { SaveDialogContent } from "./saveDialogContent";

export const show = function({ qualifiers, success }) {
    const filters = Radio.channel("main").request("get:filters");
    
    const saveDialogContent = new SaveDialogContent({
        filters,
        qualifiers
    });
    
    Dialog.show({
        title: strings.saveFilterTitle,
        buttons: [{
            role: "secondary",
            className: "dismiss",
            dismiss: true,
            caption: strings.cancel
        }, {
            role: "primary",
            caption: strings.save,
            onClick() {
                if (saveDialogContent.validate()) {
                    if (saveDialogContent.state.saveToNewFilter) {
                        const newFilter = filters.add({
                            qualifiers: qualifiers.toString(),
                            name: saveDialogContent.getNewFilterName()
                        });
    
                        newFilter.save(null).then(() => {
                            saveDialogContent.parent.dismiss();
                            toast.success("Your filter is successfully saved");
                            success();
                            emitter.emit("tracking.track", {
                                type: "filter_created",
                                data: {
                                    name: newFilter.get("name"),
                                    qualifiers: newFilter.get("qualifiers")
                                }
                            });
                        }).catch(() => {
                            toast.error("There was an error saving your filter");
                        });
                    } else {
                        const filter = filters.findWhere({ _id: saveDialogContent.state.existingFilterId });
                        
                        if (filter) {
                            filter.save({
                                qualifiers: qualifiers.toString()
                            }).then(() => {
                                saveDialogContent.parent.dismiss();
                                toast.success("Your filter is successfully saved");
                                success();
                                
                                emitter.emit("tracking.track", {
                                    type: "filter_updated",
                                    data: {
                                        name: filter.get("name"),
                                        qualifiers: filter.get("qualifiers")
                                    }
                                });
                            }).catch(() => {
                                toast.error("There was an error saving your filter");
                            });
                        } else {
                            toast.error(strings.errorUpdatingExistingFilter);
                        }
                    }
                }
            }
        }],
        shouldFocusPrimaryButton: false,
        content: saveDialogContent,
        render: true
    });
};
